import { useFocusEffect } from "expo-router";
import { useCallback } from "react";

export function useSetPageTitle(title: string) {
  useFocusEffect(
    useCallback(() => {
      // for web only check
      if (typeof document !== "undefined") {
        const prev = document.title;
        document.title = `RockForce ${title}`;
        return () => {
          document.title = prev;
        }; // cleanup. restore prev screen title
      }
    }, [title]),
  );
}
